/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ISearchSymbol } from '../../search/models/search-symbol.model';
import { ISymbolWithCategory } from '../../shared/models/symbol.model';
import { Category } from '../models/market-watch-list.model';

@Injectable({
	providedIn: 'root'
})
export class AddToWatchService {
	selectedStock: ISearchSymbol | ISymbolWithCategory;

	private _selectedCategory: Category;
	get selectedCategory(): Category {
		return this._selectedCategory;
	}

	set selectedCategory(value: Category) {
		this._selectedCategory = value;
	}

	private updateAddToWatchSub: Subject<boolean> = new Subject<boolean>();
	updateAddToWatch$: Observable<boolean> = this.updateAddToWatchSub.asObservable();

	private openAddToWatchSub: Subject<boolean> = new Subject<boolean>();
	openAddToWatch$: Observable<boolean> = this.openAddToWatchSub.asObservable();

	private openAddToWatchWithSearchSub: Subject<boolean> = new Subject<boolean>();
	openAddToWatchWithSearch$: Observable<boolean> = this.openAddToWatchWithSearchSub.asObservable();

	activeWatchPanel = false;
	activeWatchWithSearchPanel = false;

	toggleWatch(state: boolean) {
		this.activeWatchPanel = state;
		this.openAddToWatchSub.next(state);
	}

	toggleWatchWithSearch(state: boolean) {
		this.activeWatchWithSearchPanel = state;
		this.openAddToWatchWithSearchSub.next(state);
	}

	updateAddToWatch() {
		this.updateAddToWatchSub.next(true);
	}
}
